import { mergeAttributes, Node } from '@tiptap/core';

// The editor package turns merge tags into badge spans before the content
// reaches the editor (MergeTagBadge.transform) and back into tokens on save
// (MergeTagBadge.revert), so this node only has to round-trip that exact span.
// The text label stays visible because the span's own text is the chip face.
export const MergeTagNode = Node.create({
	name: 'mergeTag',
	group: 'inline',
	inline: true,
	atom: true,
	selectable: true,
	// Above TextStyle (101), which would otherwise claim every span with a style.
	priority: 1000,

	addAttributes() {
		return {
			tagKey: {
				default: '',
				parseHTML: element => element.getAttribute('data-tag-key') || '',
				renderHTML: attrs => ({ 'data-tag-key': attrs.tagKey }),
			},
			tagFallback: {
				default: null,
				parseHTML: element => element.getAttribute('data-tag-fallback'),
				renderHTML: attrs =>
					attrs.tagFallback ? { 'data-tag-fallback': attrs.tagFallback } : {},
			},
			tagFormat: {
				default: null,
				parseHTML: element => element.getAttribute('data-tag-format'),
				renderHTML: attrs => (attrs.tagFormat ? { 'data-tag-format': attrs.tagFormat } : {}),
			},
			tagMaxLength: {
				default: null,
				parseHTML: element => element.getAttribute('data-tag-max-length'),
				renderHTML: attrs =>
					attrs.tagMaxLength ? { 'data-tag-max-length': attrs.tagMaxLength } : {},
			},
			label: {
				default: '',
				parseHTML: element => element.textContent || '',
				rendered: false,
			},
			// `id` is only set on a just-inserted badge (insert uses a uuid); kept so
			// the round trip is byte-stable, not used by the editor.
			id: {
				default: null,
				parseHTML: element => element.getAttribute('id'),
				renderHTML: attrs => (attrs.id ? { id: attrs.id } : {}),
			},
		};
	},

	parseHTML() {
		return [{ tag: 'span.bay-email-merge-tag' }];
	},

	renderHTML({ node, HTMLAttributes }) {
		const { id, ...rest } = HTMLAttributes;
		// Attribute order mirrors MergeTagBadge's createBadgeInput so an untouched
		// badge re-serializes identically.
		return [
			'span',
			mergeAttributes(
				{ class: 'bay-email-merge-tag', contenteditable: 'false' },
				id ? { id } : {},
				{ value: node.attrs.label },
				rest,
			),
			node.attrs.label,
		];
	},
});
